import { PropsWithChildren } from "react";

import { css } from "@compiled/react";

import UFOSegment from "@atlaskit/react-ufo/segment";

import { OptionalExceptFor } from "@/utils/typescript-utils.ts";

import { AiFocusVideo } from "./ai-focus-video.tsx";
import { Team } from "./tab-contents/team-data.tsx";

const DEFAULT_TEAM_DATA_NEW_SCREENSHOTS: ActiveTeamDataProps = {
    id: "default",
    videoLink:
        "https://dam-cdn.atl.orangelogic.com/AssetLink/438r2lhmec7014pn861g30w8kx28ty08.mp4",
    heroImage:
        "https://dam-cdn.atl.orangelogic.com/AssetLink/qgeohf56651o63ux63s54547n4v512b6/software-hero-image.webp",
    heroImageDimensions: {
        imageWidth: 1984,
        imageHeight: 1042
    }
};

export const DEFAULT_TEAM_DATA = DEFAULT_TEAM_DATA_NEW_SCREENSHOTS;

export type ActiveTeamDataProps = OptionalExceptFor<
    Team,
    "heroImage" | "heroImageDimensions"
>;

type HeroJiraCtaTemplateProps = PropsWithChildren<{
    showJiraPlusRovoHomepageChanges?: boolean;
}>;

export const HeroJiraCtaTemplate = ({
    children,
    showJiraPlusRovoHomepageChanges = false
}: HeroJiraCtaTemplateProps) => {
    return (
        <UFOSegment name="homepage-v2-hero">
            <section id="hero-jira-cta" css={jiraHeroStyles}>
                {children}
                <AiFocusVideo
                    showJiraPlusRovoHomepageChanges={
                        showJiraPlusRovoHomepageChanges
                    }
                />
            </section>
        </UFOSegment>
    );
};

const jiraHeroStyles = css({
    overflow: "hidden"
});

HeroJiraCtaTemplate.displayName = "HeroJiraCtaTemplate";
